// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42aa4d02","455":"dea9f959","977":"a9215ec6"}[chunkId] + ".chunk.js";
};